import loadable from '@loadable/component'
import { matchRoutes, Route, Routes as RouterRoutes, useLocation } from 'react-router-dom'
import { useLayoutEffect, useMemo } from 'react'
import type { ComponentType } from 'react'

import AuthRouteElement from 'components/App/Routes/AuthRouteElement'
import HttpStatus from 'components/Common/HttpStatus'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import UrlLocation from 'src/lib/url/UrlLocation'
import { useAppDispatch } from 'hooks/reduxHooks'
import { registerPageView } from 'actions/AnalyticsActions'

const CheckoutPage = loadable(() => import('checkout/Pages/CheckoutPage')) as unknown as ComponentType

const checkoutRoutePaths = [
  '/:regionCode/checkout/:cartId/:step/:cabinId',
  '/:regionCode/checkout/:step?',
  '/:regionCode/checkout/:cartId/:step',
]

const checkoutRoutes = checkoutRoutePaths.map(path => ({ path }))

function CheckoutRoutes() {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const localeStrippedLocation = useMemo(() => {
    return {
      ...location,
      pathname: new UrlLocation(location.pathname).withoutLocale().path,
    }
  }, [location])
  const matchedRoute = useMemo(() => {
    return matchRoutes(checkoutRoutes, localeStrippedLocation)?.at(-1)
  }, [localeStrippedLocation])

  useLayoutEffect(() => {
    if (!matchedRoute) return

    dispatch(registerPageView({
      template: matchedRoute.route.path,
      params: matchedRoute.params,
      path: matchedRoute.pathname,
      search: location.search,
    }))
  }, [dispatch, location.search, matchedRoute])

  return (
    <RouterRoutes>
      <Route
        path=":cartId/:step/:cabinId"
        element={(
          <AuthRouteElement showPopup path="/:regionCode/checkout/:cartId/:step/:cabinId">
            <CheckoutPage />
          </AuthRouteElement>
        )}
      />
      <Route
        path=":step?"
        element={(
          <AuthRouteElement showPopup path="/:regionCode/checkout/:step?">
            <CheckoutPage />
          </AuthRouteElement>
        )}
      />
      <Route
        path=":cartId/:step"
        element={(
          <AuthRouteElement showPopup path="/:regionCode/checkout/:cartId/:step">
            <CheckoutPage />
          </AuthRouteElement>
        )}
      />
      <Route
        path="*"
        element={(
          <HttpStatus code={404}>
            <Error404PageWithOffers />
          </HttpStatus>
        )}
      />
    </RouterRoutes>
  )
}

export default CheckoutRoutes
